import {ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, RouterStateSnapshot} from '@angular/router';
import {inject, Injectable} from '@angular/core';
import {AuthService} from './auth-service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private readonly authService: AuthService = inject(AuthService)

  canActivate(r: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot): MaybeAsync<GuardResult> {
    return this.authService.ensureInitialized().then(_ => {
        let authenticated = this.authService.isAuthenticated;

        if (!authenticated) {
          return false
        }

        let routeRoles = r.data['roles'] ?? [];
        if (!routeRoles || routeRoles.length < 1) {
          return authenticated;
        }

        for (const role of routeRoles) {
          if (this.authService.userHasRole(role)) {
            return authenticated;
          }
        }
        return false;
      }
    )
  }
}
